/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import {
  QuotationRestService,
  SystemRoleBit,
  systemRolesBitSet,
  UserRestService,
} from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { GridLayoutService } from '@gh/core-ui-grid';
import { FilteredDataQuery, getSlicedData, SlicedDataSource } from '@gh/core-data';
import {
  isSalespersonSelectItemInactive,
  SalespersonSelectItem,
  salespersonSelectItemMapper,
  UserDetailsShort,
  UserListItem,
} from '../../leads';
import { Observable } from 'rxjs';
import { map$ } from '@gh/rx/operators';
import { concat, map, partition, reverse, sortBy } from 'lodash';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class RfqManagementListBusinessService implements InitViewService {
  constructor(private quoteRest: QuotationRestService,
              private userRest: UserRestService,
              private dictionaryService: DictionaryService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('quotationList'),
      salesPersonsList: this.findAllSalesPersons(),
      filter: this.filterService.get(FilterNames.quotationList),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<any> {
    return this.quoteRest.findAllAsDataSource(filter);
  }

  findAllSalesPersons(): Observable<SalespersonSelectItem[]> {
    return this.userRest.findAllSalesPersons(true).pipe(
      map$((userList: UserListItem[]) =>
             concat(
               [],
               ...reverse(
                 partition(
                   sortBy(
                     map(userList, salespersonSelectItemMapper),
                     'name',
                   ),
                   isSalespersonSelectItemInactive)))));
  }

  findSalesPersonsByName(query: FilteredDataQuery<string>): Observable<UserDetailsShort[]> {
    return this.userRest.findAllAsDataSource({
     name: query.filter,
     showInactive: false,
     autocomplete: true,
     systemRoles: systemRolesBitSet(SystemRoleBit.SalesPerson),
   }).select(query).pipe(map$(getSlicedData));
  }
}
